function useIconRadioGroupValue(iconRadioGroupControlData, controlDefinition) {
  return iconRadioGroupControlData ?? controlDefinition.config.defaultValue;
}
export {
  useIconRadioGroupValue
};
//# sourceMappingURL=icon-radio-group.js.map